import { useMemo } from 'react';

import {
  groupLegalDocuments,
  useLegalDocuments,
  type LegalDocumentGroup,
} from '@/modules/legalDocuments';

export type AccountLegalDocuments = {
  legalGroups: LegalDocumentGroup[];
  legalAdditionalLanguages: string[];
  legalError: unknown;
  // Block submission while the legal-documents catalog is loading OR if it
  // failed to load. The agreements schema is a `z.record` that passes on an
  // empty object, so without this gate a fetch error (no checkboxes rendered)
  // would let the user create an account with zero consent recorded. A
  // legitimately empty catalog (already-signed user) still loads without error,
  // so this only blocks the failure case.
  isLegalUnavailable: boolean;
};

// Shared legal-documents wiring for the account-creation flows: the grouped
// catalog + the loading/error gate used to disable Continue.
export function useAccountLegalDocuments(): AccountLegalDocuments {
  const {
    documents: legalDocuments,
    additionalLanguages: legalAdditionalLanguages,
    isLoading: legalIsLoading,
    error: legalError,
  } = useLegalDocuments();
  const legalGroups = useMemo(() => groupLegalDocuments(legalDocuments), [legalDocuments]);

  return {
    legalGroups,
    legalAdditionalLanguages,
    legalError,
    isLegalUnavailable: legalIsLoading || legalError != null,
  };
}
